import { IBalance } from './IBalance'
export enum RoleType {
  admin = 'admin',
  sadmin = 'sadmin',
  smdl = 'smdl',
  mdl = 'mdl',
  dl = 'dl',
  user = 'user',
}

export const RoleName: Record<string, string> = {
  admin: 'Super Admin',
  sadmin: 'Admin',
  smdl: 'SMDL',
  mdl: 'MDL',
  dl: 'DL',
  user: 'USER',

}
export default interface User {
  _id?: string
  username: string
  password?: string
  role?: RoleType
  partnership?: PartnershipType
  userSetting?: IUserBetInfo
  parentId?: any
  parentStr?: []
  passwordConfirmation?: string
  parent?: string
  partnershipOur?: any
  fullname?: string
  city?: string
  phone?: number
  creditRefrences?: number
  exposerLimit?: number
  minbet?: any
  maxbet?: any
  delay?: any
  balance?: IBalance
  isLogin?: boolean
  betLock?: boolean
  logs?: string
  transactionPassword?: string
  selected?: boolean
  subusers?: Array<ISubuser>
  subuserPermissions?: ISubuserPermissions
  loggedInAsSubuser?: string
  [key: string]: any
}

export type PartnershipAllRatioType = { parent: string; ratio: number }

export type PartnershipType = Record<
  string,
  { ownRatio: number; allRatio: Array<PartnershipAllRatioType> }
>

export type IUserBetInfo = Record<
  string,
  { minBet: number; maxBet: number; delay: number; transactionPassword?: string }
>


export type ISubuserPermissions = {
  user_deposit: boolean
  user_withdraw: boolean
  add_user: boolean
  user_status_active_inactive: boolean
  bet_status_enable_disable: boolean
  user_password_update: boolean
  event_enable_disable: boolean
  report_hide_show: boolean
  accept_decline_wallet_deposit_request: boolean
  accept_decline_wallet_withdraw_request: boolean
  admin_pnl: boolean
  result_declare: boolean
  market_analysis: boolean
  casino_control: boolean
  payment_details: boolean
  series_setting: boolean
  account_statement: boolean
  profit_loss: boolean
  game_report: boolean
  user_book: boolean
  exposure_limit: boolean
  credit_reference: boolean
  user_password: boolean
  change_status: boolean
  general_settings: boolean
  user_transaction_password: boolean
  list_of_client: boolean
  create_admin: boolean
  create_smdl: boolean
  create_mdl: boolean
  create_dl: boolean
  create_user: boolean
  add_subuser: boolean
  update_subuser: boolean
}

export type ISubuser = {
  username: string
  password?: string
  permissions: ISubuserPermissions
  createdAt?: Date
  updatedAt?: Date
}
